import { AxiosInstance } from 'axios';
import Qs from 'query-string';
import { GarbageDetectionForm } from 'common-package/src/constants';
import { AntiSpamSwitchType } from 'common-package';
import { CenterActivityInfo } from '../activityEntrance/utils';

export interface ActivityRecList {
  cloud_game_url: string;
  content: string;
  is_show: boolean;
  key: string;
  name: string;
  top_image: string;
}

// eslint-disable-next-line react-func/max-lines-per-function
const centerActivity = ({
  GateWayInstance,
  OfficialGateWayInstance,
}: {
  GateWayInstance: AxiosInstance;
  OfficialGateWayInstance: AxiosInstance;
}) => ({
  getCenterActivity(data: Record<string, any>) {
    return GateWayInstance.get<{ items: CenterActivityInfo[]; total: number }>(
      `/activities/center_list?${Qs.stringify({ ...data })}`,
    );
  },
  getActivityInfoById({ code, ...restData }: { code: string; valid_code?: string; valid_key?: string }) {
    return GateWayInstance.get(`/activities/player_code/${code}?${Qs.stringify({ ...restData })}`);
  },
  getActivityInfoByCode({ code, ...restData }: { code: string; valid_code?: string; valid_key?: string }) {
    return GateWayInstance.get(`/activities/code/${code}?${Qs.stringify({ ...restData })}`);
  },
  getGarbageDetection(formData: GarbageDetectionForm, aid?: string, switchType?: AntiSpamSwitchType) {
    return GateWayInstance.post(`/antispam`, {
      ...formData,
    })
      .then(data => data.data)
      .catch(err => err?.response?.data);
  },
  getActivityRec() {
    return OfficialGateWayInstance.get<ActivityRecList[]>(`/web/conf/activity_rec`);
  },
});

export default centerActivity;
